<template lang='pug'>
  .js-sidebar.accordion.accordion-sidebar(
    :class='{ "is-fixed": isFixed, "is-absolute": isAbsolute, "at-top": atTop, "at-bottom": atBottom }'
    :style='{ "width": filterWidth, "top": filterStickyTop }'
    v-if='entityLoaded'
    role='tablist'
  )
    .card.card-light
      #skin-concerns-heading.card-header(data-toggle='collapse' data-target='#skin-concerns-collapse' role='tab' @click='debounceFilterSize(accordionTransitionDelay)')
        i.collapse-arrow(v-if='activeFirstLevelCategories.length > 0')
        h1.h4(v-text='entityTitle')

      #skin-concerns-collapse.collapse.show(aria-labelledby='skin-concerns-heading' role='tabpanel' v-if='activeFirstLevelCategories.length > 0')
        .card-block
          ul
            li(v-for='firstLevelCategory in activeFirstLevelCategories')
              router-link(:class='{ "active": isCategoryActive(firstLevelCategory) }' :to='filterCategoryLink(firstLevelCategory)' @click.native='setFilterCategory')
                | {{ firstLevelCategory.attributes['label'] }}
                //- span.badge.badge-default 512

              template(v-if='availableChildCategoriesFor(firstLevelCategory) && availableChildCategoriesFor(firstLevelCategory).length > 0')
                ul.secondary(v-show='showAvailableSubcategoriesForCategory(firstLevelCategory)')
                  li(v-for='secondLevelCategory in availableChildCategoriesFor(firstLevelCategory)')
                    router-link(:class='{ "active": isCategoryActive(secondLevelCategory) }' :to='filterCategoryLink(secondLevelCategory)' @click.native='setFilterCategory')
                      | {{ secondLevelCategory.attributes['label'] }}

                    template(v-if='availableChildCategoriesFor(secondLevelCategory) && availableChildCategoriesFor(secondLevelCategory).length > 0')
                      ul.secondary(v-show='showAvailableSubcategoriesForCategory(secondLevelCategory)')
                        li(v-for='thirdLevelCategory in availableChildCategoriesFor(secondLevelCategory)')
                          router-link(:class='{ "active": isCategoryActive(thirdLevelCategory) }' :to='filterCategoryLink(thirdLevelCategory)' @click.native='setFilterCategory')
                            | {{ thirdLevelCategory.attributes['label'] }}

    .card.card-light(v-if='(displayBrands && displayBrands.length > 0) || !!displayBrandSearch')
      button.btn.btn-sm.btn-block.clear-all-btn(:disabled='disableClearAllButton' @click='resetAllFilters' v-text='$t("clearAllFilters")')

      #brands-heading.card-header(data-toggle='collapse' data-target='#brands-collapse' role='tab' @click='debounceFilterSize(accordionTransitionDelay)')
        i.collapse-arrow
        h4.h4(v-text='$t("brands")')

      #brands-collapse.collapse.show(role='tabpanel' aria-labelledby='brands-heading')
        .card-block
          .filter-brands-search
            input.form-control.filter-search-bar(type='text' v-model='displayBrandSearch' :placeholder='$t("products.brand.searchBrands")')
            span.filter-brands-search-icon
          .filter-list-container
            ul
              li.form-check(v-for='brand in displayBrands')
                a.form-check-label.filter-link(:href='filterBrandLink(brand)' @click.prevent='toggleFilter("brand", brand.attributes["slug-url"])')
                  span.form-check-input.checkbox(:class='[`filter-svg-brand-${brand.attributes["slug-url"]}`, { "checked": isBrandSelected(brand) }]')
                  span.filter-value-text(:class='`filter-span-brand-${brand.attributes["slug-url"]}`') {{ brand.attributes.name }}
                  //- span.badge.badge-default(v-if='brand.count > 0') 16

    .card.card-light(v-if='showPriceRange')
      #price-heading.card-header(data-toggle='collapse' data-target='#price-collapse' role='tab' @click='debounceFilterSize(accordionTransitionDelay)')
        i.collapse-arrow
        h4.h4(v-text='$t("products.filters.price")')

      #price-collapse.collapse.show(role='tabpanel' aria-labelledby='price-heading')
        .card-block
          products-price-filter

    .card.card-light(v-for='filterType in availableCustomFilters')
      .card-header(:id='`filter-type-${filterType.id}-heading`' data-toggle='collapse' :data-target='`#filter-type-${filterType.id}-collapse`' role='tab' @click='debounceFilterSize(accordionTransitionDelay)')
        i.collapse-arrow
        h4.h4(v-text='filterType.attributes.name')

      .collapse.show(:id='`filter-type-${filterType.id}-collapse`' role='tabpanel' :aria-labelledby='`filter-type-${filterType.id}-heading`')
        .card-block
          .filter-list-container
            ul
              li.form-check(v-for='filterValue in filterValuesFor(filterType)')
                a.form-check-label.filter-link(:href='filterCustomLink(filterType, filterValue)' @click.prevent='toggleFilterCustomSlugs({ type: filterType, value: filterValue })')
                  span.form-check-input.checkbox(:class='[`filter-svg-${customFilterClass(filterType.attributes.name)}-${customFilterClass(filterValue.attributes.value)}`, { "checked": isCustomValueSelected(filterType, filterValue) }]')
                  span.filter-value-text(:class='`filter-span-${customFilterClass(filterType.attributes.name)}-${customFilterClass(filterValue.attributes.value)}`' v-text='filterValue.attributes.value')

    .card.card-light(v-if='displayOtherFilters')
      #others-heading.card-header(data-toggle='collapse' data-target='#others-collapse' role='tab' @click='debounceFilterSize(accordionTransitionDelay)')
        i.collapse-arrow
        h4.h4(v-text='$t("products.filters.others")')

      #others-collapse.collapse.show(role='tabpanel' aria-labelledby='others-heading')
        .card-block
          ul
            li.form-check(v-if='availableOtherFilters.indexOf("on_sale") !== -1')
              a.form-check-label.filter-link(:href='filterOtherLink("sale")' @click.prevent='toggleFilter("other", "on_sale")')
                span.form-check-input.checkbox.filter-svg-other-on-sale(:class='{ "checked": filterOthers && filterOthers.indexOf("on_sale") !== -1 }')
                span.filter-value-text.filter-span-other-on-sale(v-text='$t("products.filters.onSale")')
</template>

<i18n>
{
  "lng_en": {
    "brands": "Brands",
    "clearAllFilters": "Clear all filters"
  },
  "lng_id": {
    "brands": "Brands",
    "clearAllFilters": "Clear all filters"
  },
  "lng_th": {
    "brands": "Brands",
    "clearAllFilters": "Clear all filters"
  },
  "lng_zh": {
    "brands": "品牌",
    "clearAllFilters": "清除所有篩選條件"
  },
  "lng_ko": {
    "brands": "브랜드",
    "clearAllFilters": "모든 필터 해제"
  }
}
</i18n>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { parameterize } from '@/modules/services/utilities'
import { brandUtil } from '@/mixins/brandUtil'
import { filtersMixins } from '@/mixins/filtersMixins'
import stickyFilters from '@/mixins/stickyFilters'
import ProductsPriceFilter from './products-price-filter.vue'

export default {
  components: {
    ProductsPriceFilter
  },

  mixins: [
    brandUtil,
    stickyFilters,
    filtersMixins
  ],

  data () {
    return {
      displayBrandSearch: ''
    }
  },

  computed: {
    ...mapState({
      entity: state => state.product.entity,
      entitySlug: state => state.product.entitySlug,
      entityType: state => state.product.entityType,
      entityLoaded: state => state.product.entityLoaded,
      availableBrands: state => state.product.availableBrands,
      filterCategorySlug: state => state.category.filterCategorySlug,
      filterBrandSlugs: state => state.product.filterBrandSlugs,
      filterPrice: state => state.product.filterPrice,
      availableOtherFilters: state => state.product.availableOtherFilters,
      filterOthers: state => state.product.filterOthers,
      availableCustomFilters: state => state.product.availableCustomFilters,
      availableCustomFilterValues: state => state.product.availableCustomFilterValues,
      filterCustomSlugs: state => state.product.filterCustomSlugs
    }),

    ...mapGetters([
      'activeCategory',
      'activeFirstLevelCategories',
      'availableChildCategoriesFor',
      'showAvailableSubcategoriesForCategory',
      'entityPath',
      'filterValuesFor',
      'filterTypeFor'
    ]),

    displayBrands () {
      if (this.displayBrandSearch) {
        return this.availableBrands.filter(
          brand => this.normalizeAccentedBrandName(brand.attributes.name).includes(
            this.normalizeAccentedBrandName(this.displayBrandSearch)
          )
        )
      } else {
        return this.availableBrands
      }
    },

    disableClearAllButton () {
      return !(
        !!this.displayBrandSearch ||
        this.filterBrandSlugs.length > 0 ||
        Object.keys(this.filterPrice).length !== 0 ||
        this.filterCustomSlugs.length > 0 ||
        this.filterOthers.length > 0
      )
    },

    displayOtherFilters () {
      return (this.availableOtherFilters && this.availableOtherFilters.length > 0 && this.entitySlug !== 'sale')
    },

    entityTitle () {
      if (this.entityType === 'search') {
        return this.entitySlug
      } else {
        return this.entity.attributes['label'] || this.entity.attributes['name'] || this.entity.attributes['title'] || this.entity.attributes['code']
      }
    }
  },

  methods: {
    ...mapMutations([
      'toggleFilterBrandSlugs',
      'toggleFilterOthers'
    ]),

    ...mapActions([
      'toggleFilterCustomSlugs'
    ]),

    isBrandSelected (brand) {
      return this.filterBrandSlugs.indexOf(brand.attributes['slug-url']) !== -1
    },

    isCustomValueSelected (type, value) {
      const filter = this.filterCustomSlugs.find(filter => filter.type.id === type.id)
      return filter && filter.values.find(v => v.id === value.id)
    },

    isCategoryActive (category) {
      return category.id === this.activeCategory.id
    },

    toggleFilter (type, value) {
      if (type === 'brand') {
        this.toggleFilterBrandSlugs(value)
      } else if (type === 'other') {
        this.toggleFilterOthers(value)
      } else if (type === 'custom') {
        this.toggleFilterCustomSlugs(value)
      }
      this.scrollToTop()
    },

    resetAllFilters () {
      this.displayBrandSearch = null
      this.$store.dispatch('resetAllFilters')
    },

    customFilterClass (label) {
      return label.toLowerCase().split(' ').join('_')
    },

    setFilterCategory () {
      this.$store.commit('setPage', 1)
    },

    filterCategoryLink (category) {
      const query = {
        view: this.$route.query.view,
        sort: this.$route.query.sort,
        brands: this.$route.query.brands,
        'min-price': this.$route.query['min-price'],
        'max-price': this.$route.query['max-price'],
        other: this.$route.query.other
      }
      return this.entityPath(category.attributes['slug-url'], query)
    },

    filterBrandLink (brand) {
      const brands = this.filterBrandSlugs.concat(brand.attributes['slug-url']).sort()
      const query = Object.assign({}, this.$route.query, {
        brands: brands.join(',')
      })
      const entityPath = this.entityPath(this.filterCategorySlug, query)
      return this.$router.resolve(entityPath).href
    },

    filterCustomLink (type, value) {
      const availableFilterType = this.availableCustomFilters.find(t => t.id === type.id)
      const availableFilterTypeSlug = parameterize(availableFilterType.attributes.name)

      const filter = this.filterCustomSlugs.find(f => f.type.id === type.id)

      let filterValues = filter ? filter.values.concat() : []
      const valueIndex = filterValues.findIndex(v => v.id === value.id)
      if (valueIndex === -1) {
        filterValues = filterValues.concat(value)
      } else {
        filterValues.splice(valueIndex, 1)
      }
      const filterValueSlugs = filterValues.map(v => parameterize(v.attributes.value)).sort()

      const unorderedQuery = Object.assign({}, this.$route.query, {
        [availableFilterTypeSlug]: filterValueSlugs.join()
      })
      if (filterValueSlugs.length === 0) {
        delete unorderedQuery[availableFilterTypeSlug]
      }
      const query = {}
      Object.keys(unorderedQuery).sort().forEach((filterTypeSlug) => {
        query[filterTypeSlug] = unorderedQuery[filterTypeSlug]
      })
      const entityPath = this.entityPath(this.filterCategorySlug, query)
      return this.$router.resolve(entityPath).href
    },

    filterOtherLink (filter) {
      const query = Object.assign({}, this.$route.query, {
        other: filter
      })
      const entityPath = this.entityPath(this.filterCategorySlug, query)
      return this.$router.resolve(entityPath).href
    },

    scrollToTop () {
      this.$scrollTo('#product-index-content', 300, {
        offset: -80
      })
    }
  }
}
</script>

<style lang='scss' scoped>
  .is-fixed {
    position: fixed;
  }

  .is-absolute {
    position: absolute;
  }

  .at-bottom {
    bottom: 40px;
  }

  .at-top {
    top: 90px;
  }

  .filter-brands-search-icon {
    position: absolute;
    right: 0;
    top: 0;
    height: 28px;
    width: 28px;
    display: inline-block;
    background-image: url('../../../assets/images/icons/search-grey-light.svg');
    background-size: 13px 13px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .filter-brands-search {
    position: relative;
    margin-bottom: 12px;
  }

  .filter-search-bar {
    height: 28px;
    padding-top: 6px;
    padding-left: 5px;
    font-size: 14px;
  }

  .filter-link {
    display: flex;

    .form-check-input {
      min-width: 18px;
    }
  }

  .form-control:focus + .filter-brands-search-icon {
    background-image: url('../../../assets/images/icons/search-grey.svg');
  }

  .clear-all-btn {
    margin-top: 12px;
    padding: 9px 10px;
  }

  .accordion-sidebar {
    .card-header .h4 {
      text-transform: uppercase;
      width: 90%;
      line-height: 20px;
    }

    li .active {
      color: $brand-primary;
    }
  }

  .filter-list-container {
    max-height: 127px;
    overflow-y: auto;
    padding-right: 15px;
    margin-top: 2px;
    margin-bottom: 4px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: $grey-light;
    }

    &::-webkit-scrollbar-thumb {
      background: $grey-mid;
    }

    .form-check:first-child {
      margin-top: 0;
    }

    .form-check:last-child {
      margin-bottom: 0;
    }
  }

  .filter-value-text {
    line-height: 15px;
    padding-top: 2px;
  }
</style>
